import Cookies from "universal-cookie";

const TOKEN_KEY = "jwt";
const cookies = new Cookies();

export const login = () => {
  console.log('in login const')
  cookies.set(TOKEN_KEY, "TestLogin");
};

export const logout = () => {
  cookies.remove(TOKEN_KEY);
};

export const isLogin = () => {
  console.log("cookies", cookies.get("jwt"));
  if (cookies.get("jwt") == "TestLogin") {
    console.log("cookies true", cookies.get("jwt"));
    return true;
  } else {
    console.log('in else')
    return false;
  }
};
